import React, { useState } from 'react';
import { classes } from 'typestyle';
import {
    collapsibleContentClassName,
    collapsibleContentTitleClassName,
    collapsibleContentContentClassName,
    collapsibleContentTitleOpenContentClassName,
    collapsibleContentTitleDisabledClassName,
    collapsibleContentLineClassName,
    collapsibleContentIconClassName
} from './collapsible-content.style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';

interface CollapsibleContentProps {
    title: string,
    children?: React.ReactNode,
    initExpanded?: boolean,
    line?: boolean
}

const CollapsibleContent: React.FC<CollapsibleContentProps> = ({
    title,
    children,
    initExpanded = false,
    line = true
}) => {
    const [showContent, changeShowContent] = useState<boolean>(initExpanded);

    return (
        <div className={ collapsibleContentClassName }>
            <div
                className={ classes(
                    collapsibleContentTitleClassName,
                    !children && collapsibleContentTitleDisabledClassName,
                    !!children && showContent && collapsibleContentTitleOpenContentClassName
                ) }
                onClick={ () => changeShowContent(!showContent) }
                children={ (
                    <>
                        { title }
                        { children && (
                            <span className={ collapsibleContentIconClassName }>
                                {!showContent && <FontAwesomeIcon icon={faPlus} />}
                                {showContent && <FontAwesomeIcon icon={faXmark} />}
                            </span>
                        ) }
                    </>
                ) }/>
            { line && <div className={ collapsibleContentLineClassName }/> }
            { (children && showContent) && (
                <div className={ collapsibleContentContentClassName }>
                    { children }
                </div>
            ) }
        </div>
    );
};

export default CollapsibleContent;
